import { APP_NAME } from '../constants';

const SEND_EMAIL_URL =
  'https://nxvochdgdtnhbjbdckkw.supabase.co/functions/v1/send-email';

function escapeHtml(value) {
  return String(value || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

/**
 * Notifie l'utilisateur que son mot de passe a été modifié (par un admin).
 */
export async function sendPasswordChangedEmail({
  email,
  password,
  fullName = '',
}) {
  const to = String(email || '').trim().toLowerCase();
  if (!to) {
    throw new Error('Adresse email manquante pour l’envoi');
  }
  if (!password) {
    throw new Error('Mot de passe manquant pour l’envoi');
  }

  const displayName = fullName?.trim() || to;
  const safeName = escapeHtml(displayName);
  const safeEmail = escapeHtml(to);
  const safePassword = escapeHtml(password);
  const loginUrl = `${window.location.origin}/login-authentication`;

  const htmlContent = `
    <!DOCTYPE html>
    <html lang="fr">
    <head>
      <meta charset="UTF-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <title>Mot de passe mis à jour</title>
      <style>
        body { font-family: Arial, sans-serif; line-height: 1.6; color: #333; max-width: 600px; margin: 0 auto; padding: 20px; }
        .header { background-color: #1a56db; color: white; padding: 20px; text-align: center; border-radius: 10px 10px 0 0; }
        .content { background-color: #f9fafb; padding: 30px; border-radius: 0 0 10px 10px; border: 1px solid #e5e7eb; border-top: none; }
        .credentials { background-color: #fff; border: 1px solid #e5e7eb; border-radius: 8px; padding: 20px; margin: 20px 0; }
        .credentials p { margin: 10px 0; }
        .button { display: inline-block; background-color: #1a56db; color: white !important; text-decoration: none; padding: 12px 24px; border-radius: 6px; margin-top: 12px; }
        .warning { background-color: #fef3c7; border-left: 4px solid #f59e0b; padding: 12px; margin: 20px 0; font-size: 14px; }
        .footer { margin-top: 24px; padding-top: 16px; border-top: 1px solid #e5e7eb; font-size: 12px; color: #6b7280; text-align: center; }
      </style>
    </head>
    <body>
      <div class="header">
        <h1>Mot de passe mis à jour</h1>
      </div>
      <div class="content">
        <p>Bonjour ${safeName},</p>
        <p>
          Votre mot de passe sur <strong>${escapeHtml(APP_NAME)}</strong> a été modifié par un administrateur.
        </p>
        <div class="credentials">
          <p><strong>Email :</strong> ${safeEmail}</p>
          <p><strong>Nouveau mot de passe :</strong>
            <span style="font-family: monospace; background:#f3f4f6; padding:4px 8px; border-radius:4px;">${safePassword}</span>
          </p>
        </div>
        <div class="warning">
          Pour votre sécurité, connectez-vous puis changez ce mot de passe si vous le souhaitez.
          Ne communiquez jamais vos identifiants.
        </div>
        <p style="text-align:center;">
          <a class="button" href="${loginUrl}">Se connecter</a>
        </p>
        <p>
          Cordialement,<br/>
          L’équipe ${escapeHtml(APP_NAME)}
        </p>
        <div class="footer">
          <p>Cet email a été envoyé automatiquement, merci de ne pas y répondre.</p>
        </div>
      </div>
    </body>
    </html>
  `;

  const response = await fetch(SEND_EMAIL_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      to,
      subject: `🔑 Votre mot de passe ${APP_NAME} a été mis à jour`,
      html: htmlContent,
    }),
  });

  if (!response.ok) {
    throw new Error(`Erreur d’envoi de l’email (${response.status})`);
  }

  return true;
}
